const es = {
  // Common
  app_name: "VRS",
  app_subtitle: "Escaner de Riesgo de Proveedores",
  loading: "Cargando...",
  save: "Guardar",
  cancel: "Cancelar",
  back: "Volver",
  next: "Siguiente",
  submit: "Enviar",
  close: "Cerrar",
  search: "Buscar",
  filter: "Filtrar",
  actions: "Acciones",
  edit: "Editar",
  delete: "Eliminar",
  create: "Crear",
  download: "Descargar",
  view: "Ver",
  details: "Detalles",
  confirm: "Confirmar",
  yes: "Si",
  no: "No",
  na: "N/A",
  all: "Todos",
  none: "Ninguno",
  or: "o",

  // Status
  status_pending: "Pendiente",
  status_running: "En Proceso",
  status_completed: "Completado",
  status_failed: "Fallido",
  status_active: "Activo",
  status_deactivated: "Desactivado",
  status_draft: "Borrador",
  status_approved: "Aprobado",
  status_archived: "Archivado",

  // Compliance
  compliant: "Cumple",
  non_compliant: "No Cumple",
  at_risk: "En Riesgo",
  unable_to_determine: "No Determinado",
  requires_internal_audit: "Requiere Auditoria Interna",
  not_applicable: "No Aplica",
  partial: "Parcial",

  // Maturity
  maturity_low: "Bajo",
  maturity_moderate: "Moderado",
  maturity_high: "Alto",
  maturity_excellent: "Excelente",
  maturity_level: "Nivel de Madurez",

  // Auth
  sign_in: "Iniciar Sesion",
  sign_up: "Registrarse",
  log_in: "Entrar",
  log_out: "Cerrar Sesion",
  email_address: "Direccion de correo electronico",
  password: "Contrasena",
  forgot_password: "Olvidaste tu contrasena?",
  send_verification_code: "Enviar codigo de verificacion",
  verify_and_sign_in: "Verificar e iniciar sesion",
  enter_credentials: "Ingrese sus credenciales para acceder a su cuenta",
  dont_have_account: "No tienes una cuenta?",
  register_here: "Registrate aqui",
  already_have_account: "Ya tienes una cuenta?",
  sign_in_link: "Iniciar sesion",
  verification_code: "Codigo de verificacion",
  new_password: "Nueva contrasena",
  reset_password: "Restablecer contrasena",
  send_reset_code: "Enviar codigo de restablecimiento",
  back_to_login: "Volver al inicio de sesion",
  forgot_your_password: "Olvidaste tu contrasena?",
  enter_email_reset: "Ingresa tu correo y te enviaremos un codigo de restablecimiento.",
  password_reset_success: "Contrasena restablecida!",
  sign_in_new_password: "Iniciar sesion con nueva contrasena",

  // Registration
  registration: "Registro",
  user_information: "Informacion del Usuario",
  scope_questions: "Preguntas de Alcance",
  review_submit: "Revisar y Enviar",
  email_verification: "Verificacion de Correo",
  select_your_role: "Selecciona Tu Rol",
  full_name: "Nombre Completo",
  entity_type: "Tipo de Entidad",
  entity_email: "Correo Electronico de la Entidad",
  entity_name: "Nombre de la Entidad",
  entity_url: "URL de la Entidad",
  entity_description: "Descripcion de la Entidad (opcional)",
  government_agency: "Agencia de Gobierno",
  company: "Empresa",
  individual: "Individual",
  step_x_of_y: "Paso {x} de {y}",
  provide_basic_info: "Proporcione su informacion basica para crear una cuenta",
  help_understand_scope: "Ayudenos a comprender su alcance de cumplimiento",
  review_info_submit: "Revise su informacion y envie para recibir un codigo de verificacion",
  enter_6digit_code: "Ingrese el codigo de 6 digitos enviado a {email}",
  choose_how_use_vrs: "Elija como utilizara VRS",

  // CISA
  cisa_sectors_label: "Sectores de Infraestructura Critica CISA",
  cisa_sectors_desc: "Seleccione todos los sectores que aplican a su entidad.",

  // PR Gov
  pr_gov_business: "Negocios con el Gobierno de Puerto Rico",
  pr_gov_q1: "Hace negocios con el Gobierno de Puerto Rico?",
  pr_gov_q2: "Provee servicios o realiza contratos que involucran funciones publicas, servicios publicos, o uso/inversion de fondos publicos, o trabaja bajo autoridad gubernamental?",
  pr_gov_q3: "Maneja, almacena, transmite o de otra manera gestiona datos gubernamentales o activos de informacion, o provee servicios ICT a agencias?",
  pr_gov_warning: "Responder 'si' a cualquiera de estas preguntas lo incluira en una revision de cumplimiento para proveedores de entidades gubernamentales.",

  // Federal Gov
  fed_gov_business: "Negocios con el Gobierno Federal",
  fed_gov_q1: "Tiene contratos con Provisiones FAR?",
  fed_gov_q2: "Tiene contratos con Provisiones DFARS?",

  // Roles
  role_compliance: "Cumplimiento",
  role_compliance_desc: "Verificar su propia puntuacion de cumplimiento",
  role_compliance_subtitle: "Escanear los activos externos de su propia entidad",
  role_procurement: "Adquisiciones",
  role_procurement_desc: "Verificar puntuaciones de otras entidades",
  role_procurement_subtitle: "Escanear proveedores y socios terceros",
  role_regulatory: "Regulatorio",
  role_regulatory_desc: "Ver base de datos de todos los escaneos y resultados",
  role_regulatory_subtitle: "Solo para reguladores gubernamentales autorizados",
  role_regulatory_restricted: "Las cuentas regulatorias requieren un dominio de correo .gov.",
  complete_registration: "Completar Registro",

  // Dashboard
  dashboard: "Panel de Control",
  welcome_back: "Bienvenido de vuelta",
  compliance_overview: "Aqui esta su resumen de cumplimiento.",
  new_scan: "Nuevo Escaneo",
  compliance_score: "Puntuacion de Cumplimiento",
  overall_average: "Promedio general",
  assets_monitored: "Activos Monitoreados",
  total_scanned: "Objetivos escaneados totales",
  open_findings: "Hallazgos Abiertos",
  across_all_scans: "En todos los escaneos",
  regulations_mapped: "Regulaciones Mapeadas",
  active_law_benchmarks: "Puntos de referencia legales activos",
  recent_scans: "Escaneos Recientes",
  view_all: "Ver todos",
  no_scans_yet: "Sin escaneos aun",
  start_first_scan: "Inicie su primer escaneo de cumplimiento para ver resultados aqui.",
  start_first_scan_btn: "Iniciar Primer Escaneo",
  compliance_overview_title: "Resumen de Cumplimiento",
  by_category: "Por Categoria",
  no_data: "Sin datos",

  // Sidebar
  nav_dashboard: "Panel",
  nav_scans: "Escaneos",
  nav_laws: "Leyes y Regulaciones",
  nav_categories: "Categorias",
  nav_subscriptions: "Suscripciones",
  nav_fines: "Multas",
  nav_public_scores: "Puntuaciones Publicas",
  nav_settings: "Configuracion",
  nav_admin: "Consola de Admin",

  // Scans
  scans: "Escaneos",
  manage_scans: "Ver y administrar sus escaneos de cumplimiento.",
  run_scan: "Ejecutar Escaneo de Cumplimiento",
  run_scan_desc: "Ingrese una URL para escanear problemas de accesibilidad y cumplimiento.",
  target_url: "URL Objetivo",
  start_scan: "Iniciar Escaneo",
  scan_initiated: "Escaneo iniciado!",
  scanning: "Escaneando {url}",
  scan_results: "Resultados del Escaneo",
  scanning_in_progress: "Escaneo en progreso...",
  analyzing_url: "Analizando {url}",
  scan_may_take: "Esto puede tomar 1-3 minutos dependiendo del numero de tipos de escaneo",
  scan_failed: "Escaneo Fallido",
  try_again: "Intentar de Nuevo",
  overall_compliance_score: "Puntuacion General de Cumplimiento",
  law_by_law_results: "Resultados Ley por Ley",
  all_categories: "Todas las categorias",
  sort_by_category: "Ordenar por Categoria",
  score_low_first: "Puntuacion (Menor primero)",
  score_high_first: "Puntuacion (Mayor primero)",
  download_report: "Descargar Reporte",
  full_report_pdf: "Reporte Completo de Cumplimiento (PDF)",
  summary_report_pdf: "Resumen de Alto Nivel (PDF)",
  generate_fine_report: "Generar Reporte de Multa",
  what_scan_checks: "Que verifica este escaneo",
  scan_disclaimer: "Este escaneo realiza una evaluacion basica no intrusiva. No realiza explotacion activa ni pruebas de penetracion.",
  // [Phase 3(c) Stage 3.5, DEF-F4] Describe lo que el escaneo REALMENTE ejecuta
  // contra el catalogo curado. Sin OWASP ZAP / OSV-CVE (no se ejecutan). Sin base legal.
  scan_check_accessibility: "Accesibilidad (WCAG 2.1): verificaciones automaticas de barreras de accesibilidad comunes. El escaneo automatico no es exhaustivo ni sustituye una auditoria manual.",
  scan_check_privacy: "Aviso de privacidad: verifica si se ha publicado una politica de privacidad. Incluido segun su perfil.",
  scan_check_cyber: "Ciberseguridad de Puerto Rico (Ley 40-2024): verificaciones de postura de seguridad verificables pasivamente, incluidas cuando su perfil de aplicabilidad lo coloca dentro del alcance. La mayoria de las obligaciones requieren atestacion o auditoria y se muestran por separado en sus resultados.",
  scan_check_passive: "Este escaneo lee unicamente activos publicos externos. No realiza explotacion activa, escaneo de puertos ni pruebas de penetracion.",
  // [Phase 3(c) Sub-stage 2] Chrome de la interfaz del gate Ley 40 (NO las preguntas — servidas desde la BD).
  saving: "Guardando...",
  gate_intro: "Responda las siguientes preguntas de aplicabilidad de la Ley 40 de Puerto Rico. Deje cualquiera como \"Aun sin responder\" si no esta seguro — su evaluacion permanece provisional hasta responderlas todas.",
  gate_not_yet_answered: "Aun sin responder",
  gate_view_statute: "Ver estatuto (espanol)",
  gate_result_applies: "Segun sus respuestas, la Ley 40 aplica a su entidad.",
  gate_result_not_apply: "Segun sus respuestas, la Ley 40 no aplica actualmente a su entidad.",
  gate_result_provisional: "Aun no se puede determinar — {n} pregunta(s) sin responder.",
  gate_saved: "Respuestas de aplicabilidad guardadas.",
  gate_save_error: "No se pudieron guardar sus respuestas. Intente de nuevo.",
  gate_load_error: "No se pudieron cargar las preguntas de aplicabilidad.",
  reg_gate_step_title: "Aplicabilidad de la Ley 40",
  reg_gate_step_desc: "Responda las preguntas de aplicabilidad de la Ley 40 de Puerto Rico, u omitalas y complételas luego en Configuracion.",
  reg_gate_skip: "Omitir por ahora",
  reg_gate_finish: "Finalizar",
  settings_ley40_section: "Aplicabilidad de la Ley 40",
  settings_future_note: "Un area de configuracion completa llegara mas adelante. Por ahora puede revisar y actualizar sus respuestas de aplicabilidad de la Ley 40 aqui.",
  provisional_banner: "Su evaluacion de aplicabilidad de la Ley 40 es provisional — {n} pregunta(s) sin responder.",
  provisional_cta: "Complete su perfil de aplicabilidad",
  override_title: "Ley 40 para este escaneo",
  override_entity_applies: "Segun su perfil, la Ley 40 aplica a su entidad.",
  override_entity_not_apply: "Segun su perfil, la Ley 40 no aplica actualmente a su entidad.",
  override_entity_provisional: "Su perfil de aplicabilidad esta incompleto (provisional).",
  override_use_profile: "Usar la determinacion de mi perfil",
  override_include: "Incluir la Ley 40 en este escaneo",
  override_exclude: "Excluir la Ley 40 de este escaneo",
  override_note: "Esta determinacion se refiere a la entidad cuyos sistemas se escanean, que puede diferir del titular de la cuenta.",
  covered_title: "Sistemas cubiertos (alcance declarado)",
  covered_add: "Agregar sistema",
  covered_identifier: "Sistema (hostname / endpoint)",
  covered_exclude: "Excluir del escaneo",
  covered_basis: "Motivo de la exclusion (obligatorio)",
  covered_basis_required: "Excluir un sistema requiere un motivo por escrito.",

  // Scan result labels
  errors: "Errores",
  warnings: "Advertencias",
  notices: "Avisos",
  must_fix: "Debe corregir para cumplimiento",
  needs_review: "Necesita revision manual",
  best_practices: "Mejores practicas",
  findings: "Hallazgos",
  high: "Alto",
  medium: "Medio",
  low: "Bajo",
  informational: "Informativo",
  parameters: "Parametros",
  scannable: "escaneable",
  total_requirements: "requisitos totales",

  // Results disclaimer
  results_disclaimer: "Esta evaluacion analiza unicamente los activos de cara al exterior y no constituye una auditoria de cumplimiento integral. Consulte a profesionales legales y tecnicos calificados para una verificacion completa de cumplimiento.",
  remediation_contact: "Para asistencia con la remediacion de problemas identificados, contacte",

  // External scan disclaimer
  external_scan_disclaimer: "Solo Escaneo Externo: Esta evaluacion analiza {x} de {y} requisitos totales verificables desde activos publicos externos. Los {z} requisitos restantes no pueden evaluarse remotamente y requieren una auditoria interna de cumplimiento por un profesional calificado.",

  // Categories
  categories: "Categorias",
  manage_categories: "Administrar categorias de evaluacion de cumplimiento y metodologias.",
  new_category: "Nueva Categoria",
  create_category: "Crear Categoria",
  edit_category: "Editar Categoria",
  category_title: "Titulo",
  category_description: "Descripcion",
  methodology: "Metodologia",
  show_archived: "Mostrar archivados",
  no_categories_yet: "Sin categorias aun. Cree la primera.",
  archive: "Archivar",
  restore: "Restaurar",

  // Laws
  laws_regulations: "Leyes y Regulaciones",
  manage_laws: "Configurar reglas de cumplimiento y parametros escaneables para cada ley.",
  add_new_law: "Agregar Nueva Ley",
  law_title: "Titulo de la Ley",
  jurisdiction: "Jurisdiccion",
  source_url: "URL de Fuente",
  description_summary: "Descripcion / Resumen",
  scannable_parameters: "Parametros Escaneables",
  fine_schedule: "Programa de Multas",
  save_as_draft: "Guardar como Borrador",
  approve_activate: "Aprobar y Activar",
  basic_information: "Informacion Basica",
  define_parameters: "Definir Parametros Escaneables",
  review_save: "Revisar y Guardar",
  parameter_name: "Nombre del Parametro",
  scan_method: "Metodo de Escaneo",
  externally_scannable: "Escaneable externamente",
  requires_audit: "Requiere auditoria interna",
  compliance_criteria: "Criterios de Cumplimiento",
  weight: "Peso",
  add_parameter: "Agregar Parametro",
  can_result_in_fines: "Puede esta ley resultar en multas?",
  violation_description: "Descripcion de la Violacion",
  min_amount: "Monto Minimo",
  max_amount: "Monto Maximo",
  frequency: "Frecuencia",
  add_violation: "Agregar Violacion",
  per_incident: "Por Incidente",
  per_day: "Por Dia",
  per_record: "Por Registro Afectado",
  flat_fee: "Tarifa Fija",

  // Admin
  admin_console: "Consola de Administracion",
  super_admin_console: "Consola de Super Administrador",
  manage_platform: "Administrar usuarios, ver actividad y configurar la plataforma.",
  user_management: "Usuarios",
  activity_log: "Registro de Actividad",
  usage: "Uso",
  exemptions: "Exenciones",
  system_settings: "Configuracion del Sistema",
  create_user: "Crear Usuario",
  change_role: "Cambiar Rol",
  reset_password_action: "Restablecer Contrasena",
  view_activity: "Ver Actividad",
  deactivate: "Desactivar",
  reactivate: "Reactivar",
  total_users: "Total de Usuarios",
  active_subscriptions: "Suscripciones Activas",
  total_scans_run: "Escaneos Totales",
  scans_this_month: "Escaneos Este Mes",

  // Billing
  billing_subscription: "Facturacion y Suscripcion",
  manage_billing: "Administrar su plan de suscripcion y detalles de pago.",
  current_plan: "Plan Actual",
  manage_subscription: "Administrar Suscripcion",
  scans_used: "Escaneos Usados",
  next_billing: "Proxima Facturacion",
  payment_method: "Metodo de Pago",
  available_plans: "Planes Disponibles",
  subscribe: "Suscribirse",
  one_time_scan: "Escaneo Unico",
  subscription_required: "Suscripcion Requerida",

  // Fines
  fines_management: "Gestion de Multas",
  fines_desc: "Emitir, rastrear y administrar multas regulatorias.",
  total_fines: "Total de Multas",
  active_issued: "Activas (Emitidas)",
  total_amount: "Monto Total",
  entity: "Entidad",
  amount: "Monto",
  date_issued: "Fecha de Emision",
  due_date: "Fecha de Vencimiento",
  status: "Estado",
  fine_status_draft: "Borrador",
  fine_status_issued: "Emitido",
  fine_status_paid: "Pagado",
  fine_status_disputed: "Disputado",
  issue_fine_ticket: "Emitir Boleta de Multa",
  save_fine_draft: "Guardar como Borrador",
  select_violations: "Seleccionar Violaciones",
  fine_schedule_not_configured: "Programa de multas no configurado",
  fine_disclaimer: "Esta evaluacion se basa en el escaneo automatizado de activos de cara al exterior. La autoridad emisora debe verificar los hallazgos de manera independiente antes de tomar medidas de cumplimiento.",

  // Public Score
  public_compliance_profile: "Perfil Publico de Cumplimiento",
  public_profile_desc: "Comparta su puntuacion de cumplimiento publicamente mediante codigo QR o URL.",
  make_score_public: "Hacer mi puntuacion de cumplimiento publica",
  public_toggle_desc: "Cuando esta habilitado, cualquier persona con el enlace o codigo QR puede ver su puntuacion general y desglose por categoria.",
  your_qr_code: "Su Codigo QR",
  qr_desc: "Comparta este codigo QR con proveedores, socios o clientes. Cualquier persona que lo escanee puede ver su puntuacion de cumplimiento publica.",
  public_url: "URL Publica",
  download_png: "Descargar PNG",
  download_svg: "Descargar SVG",
  preview: "Vista Previa",
  copy_url: "Copiar URL",
  profile_preview: "Vista Previa del Perfil Publico",
  score_not_available: "Puntuacion No Disponible",
  score_not_public: "La puntuacion de cumplimiento de esta entidad no esta disponible publicamente.",
  verified_by_vrs: "Verificado por VRS",
  category_scores: "Puntuaciones por Categoria",
  last_scanned: "Ultimo escaneo",
  no_scan_results: "Sin resultados de escaneo aun. Ejecute un escaneo para completar su perfil publico.",

  // Landing
  landing_badge: "Plataforma de Escaneo de Cumplimiento Regulatorio",
  landing_hero: "Escaneo de Cumplimiento,",
  landing_hero_accent: "Verificado.",
  landing_desc: "Escanee sitios web y activos de cara al exterior contra leyes y regulaciones aplicables. Obtenga puntuaciones de cumplimiento deterministicas, respaldadas por evidencia, con registros de auditoria completos.",
  get_started_free: "Comenzar Gratis",
  landing_disclaimer: "VRS proporciona evaluaciones preliminares automatizadas de cumplimiento. Los resultados deben ser verificados por profesionales calificados.",
  landing_features_title: "Todo lo que necesita para la gestion de cumplimiento",
  landing_cta_title: "Listo para verificar su cumplimiento?",
  landing_cta_desc: "Comience con un escaneo gratuito. No se requiere tarjeta de credito.",
  start_scanning: "Comenzar a Escanear",
  privacy_policy: "Politica de Privacidad",
  terms_of_service: "Terminos de Servicio",
  contact: "Contacto",
  powered_by: "Impulsado por VRS",
  cybercheck_product: "Un Producto de CyberCheck LLC",

  // Features
  feature_multi_law: "Escaneo Multi-Ley",
  feature_multi_law_desc: "Verificaciones automatizadas de cumplimiento contra WCAG, HIPAA, GLBA, CMMC, Ley 40-2024, y mas.",
  feature_deterministic: "Resultados Deterministicos",
  feature_deterministic_desc: "Cada hallazgo se rastrea a una regla configurada especifica. Sin adivinanzas de IA ni alucinaciones.",
  feature_fines: "Multas Regulatorias",
  feature_fines_desc: "Genere boletas de multa con programas de violaciones referenciados legalmente.",
  feature_qr: "Puntuaciones QR Publicas",
  feature_qr_desc: "Comparta su puntuacion de cumplimiento mediante codigo QR de marca con proveedores y socios.",
  feature_reports: "Reportes Ejecutivos",
  feature_reports_desc: "Reportes PDF descargables con desgloses por categoria y guia de remediacion.",
  feature_rbac: "Acceso Basado en Roles",
  feature_rbac_desc: "Roles de Cumplimiento, Adquisiciones, Regulatorio, Entrada Legal y Administrador con RBAC.",

  // 404
  page_not_found: "Pagina no encontrada",
  page_not_found_desc: "La pagina que busca no existe o ha sido movida.",
  go_back: "Volver",

  // Topbar
  search_placeholder: "Buscar escaneos, leyes, activos...",
  notifications: "Notificaciones",
  profile: "Perfil",

  // Ley 40
  externally_scannable_params: "Parametros Escaneables Externamente",
  privacy_notice_art5: "Aviso de Privacidad (Art. 5) - Evaluado bajo la categoria de Politica de Privacidad",
  privacy_notice_art5_desc: "El octavo requisito escaneable externamente (Aviso de Privacidad) se evalua por separado bajo los resultados del escaneo de Politica de Privacidad de la Ley 39-2012 arriba.",
  internal_audit_requirements: "requisitos requieren auditoria interna (no escaneables externamente)",
};

export default es;
